var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/16/arrow_down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5001 11.7929V3H8.5001V11.7929L10.8285 9.46447C11.0238 9.2692 11.3404 9.2692 11.5356 9.46447C11.7309 9.65973 11.7309 9.97631 11.5356 10.1716L8.35365 13.3536C8.15839 13.5488 7.8418 13.5488 7.64654 13.3536L4.46456 10.1716C4.2693 9.97631 4.2693 9.65973 4.46456 9.46447C4.65982 9.2692 4.97641 9.2692 5.17167 9.46447L7.5001 11.7929Z",
    fill: "#FF3440"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.c39e0225291d870d63352a756ff10fd0.svg";
export { ForwardRef as ReactComponent };